<template>
<div style="background:#fcfcfd">
<div class="container">
    <div style="padding-top:20px"><span style="cursor:pointer" @click="gotoHome()">HOME</span> - ABOUT US - CUSTOMER</div>
    <div class="row" style="padding:30px 0px;padding-top:15px">
        <div class="col-md-3">
            <left></left>
        </div>
        <div class="col-md-9" style="color:#333;font-size:15px;line-height:25px;">
           
            <p style="text-align:center;margin-bottom:30px">
                <img src="/static/images/about-us-customer.jpeg" style="width:100%;box-shadow:0px 0px 10px #aaa"/>
            </p>
            <p>
                {{ $t('customer_1') }}
            </p>
            <p>
                {{ $t('customer_2') }}
            </p>
             <p v-if="$i18n.locale == 'en'">
            Pre-Sales service：
            <ul v-if="$i18n.locale == 'en'"><li>
Free consulting service help you to find the most suitable material for your application.</li><li>
Provide free sample for test and evaluation.</li><li>
Consulting service through your testing process.</li></ul>
            </p>
            
            <p v-if="$i18n.locale == 'en'">
            After-Sales service：
            <ul v-if="$i18n.locale == 'en'"><li>
Fast delivery and strict quality inspection for every shipment.</li><li>
Various packing available upon customer’s requirement.</li><li>
Professional service for shipment and export process.</li><li>
Technical support through your manufacturing process.</li></ul>
            </p>

            <p v-if="$i18n.locale == 'zh'">
                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。

            </p>

            <p v-if="$i18n.locale == 'zh'">
                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。

            </p>

            <p v-if="$i18n.locale == 'zh'">
                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。

            </p>

            <p v-if="$i18n.locale == 'zh'">
                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！

            </p>
        </div>
    </div>
</div>
</div>
</template>

<script>

import left from './left';
export default {
    created(){
    
    },
    mounted(){
        
    },
    components: {
        left
    },
    data(){
        return{
           
        }
    },
    methods:{
        gotoHome(){
            this.$router.push('/');
        },
    }
};
</script>

<style>
.navbar-brand-img{
    width: 150px;
    height:auto;
}
</style>



// WEBPACK FOOTER //
// customer.vue?4c9cb88b